import React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import addModal from '../../../utils/state/react_modals';

import AttendanceList from './AttendanceList'

const ReportHelpModal = props => {
    const { html, confirm } = props;

    return (
        <Modal
            isOpen={true}
            onClosed={confirm}
            onExit={confirm}
            toggle={confirm}
            className="no-print"
            backdropClassName="no-print"
            modalClassName="no-print"
            wrapClassName="no-print">
            <ModalHeader toggle={confirm}>Send Report To Host Instructions</ModalHeader>
            <ModalBody>
                <div dangerouslySetInnerHTML={{ __html: html }} />
            </ModalBody>
            <ModalFooter>
                <button type="button" onClick={confirm} className="btn btn-primary btn-block btn-lg mr-1">
                    Continue
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default observer(
    class MultiAttendanceList extends React.Component {
        showReportInstructions() {
            $.ajax({
                method: 'get',
                url: '/workshops/attendance/report-help/'
            }).then(html => {
                addModal((close, confirm) => (
                    <ReportHelpModal html={html} close={close} confirm={confirm} />
                ));
            })
        }

        render() {
            const {
                events_filtered_sorted: events,
                is_loading,
                current_event: event,
                participant_group_by,
                participant_group_by_options
            } = this.props.events;

            if (is_loading) {
                return <h2>Loading...</h2>;
            }

            return (
                <div>
                    <div className="no-print">
                        <div className="mb-2">
                            {events.length > 1 ? (
                                <>
                                    Select Event:
                                    <select
                                        className="form-control"
                                        value={this.props.events.current_event.knet_id}
                                        onChange={(e) => this.props.events.selected_event = events.find(_e => _e.knet_id == e.target.value)}>
                                        {events.map((e, i) => (
                                            e.title ? (
                                                <option
                                                    key={i}
                                                    value={e.knet_id}>
                                                    {e.title} &mdash; {e.presenters} &mdash; {e.knet_id} &mdash; {e.days.length ? e.days[0].for_header : ''}
                                                </option>
                                            ) : null
                                        ))}
                                    </select>
                                </>
                                ) : (
                                    event ? (
                                        <div className="alert alert-info">
                                            {event.title} &mdash; {event.presenters}
                                        </div>
                                    ) : null
                                )
                            }
                        </div>
                        <div>
                            Search For Participant:
                            <input
                                type="text"
                                className="form-control"
                                value={this.props.events.filter}
                                onChange={e => this.props.events.filter = e.currentTarget.value} />
                        </div>
                        <hr />
                        <div className="d-flex">
                            <div className="flex-fill">
                                Group Participants By:
                                <select
                                    className="form-control d-inline-block ml-2"
                                    style={{ width: 'auto' }}
                                    value={participant_group_by}
                                    onChange={e => this.props.events.participant_group_by = e.currentTarget.value}>
                                    {participant_group_by_options.map(o => <option key={o.key} value={o.key}>{o.name}</option>)}
                                </select>
                            </div>
                            <div>
                                <a href="#" onClick={this.showReportInstructions}>Send Report To Host</a>
                            </div>
                        </div>
                        <hr />
                    </div>
                    {event ? <AttendanceList event={event} /> : <h2>No participants found.</h2>}
                </div>
            );
        }
    }
);
